export function initTabs(root, state) {
    const tabs = [...root.querySelectorAll('[data-chalet-tab]')];
    const panels = [...root.querySelectorAll('[data-chalet-panel]')];
    function select(value, scroll = false) {
        if (!tabs.some(tab => tab.dataset.chaletTab === value)) return;
        state.set({activeTab: value});
        if (scroll) root.querySelector('[role="tablist"]').scrollIntoView({behavior: 'smooth', block: 'start'});
    }
    state.subscribe(({activeTab}) => {
        tabs.forEach(tab => {
            const selected = tab.dataset.chaletTab === activeTab;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            tab.parentElement.classList.toggle('rg-tab-item--active', selected);
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.chaletPanel !== activeTab; });
    });
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.chaletTab));
        tab.addEventListener('keydown', event => {
            const offsets = {ArrowLeft: -1, ArrowRight: 1};
            let next;
            if (event.key in offsets) next = (index + offsets[event.key] + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            select(tabs[next].dataset.chaletTab);
            tabs[next].focus();
        });
    });
    root.querySelectorAll('[data-chalet-show]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        select(link.dataset.chaletShow, true);
    }));
    const readHash = () => select(window.location.hash.slice(1));
    window.addEventListener('hashchange', readHash);
    readHash();
}
